import React from "react";
import "../Css/Accounts.css";
import {calculateYears} from "../About/About";
import {Skill} from "../types";

interface SkillSectionProps {
    skills?: Skill[],
}

export function SkillSection({skills}:SkillSectionProps) {

    return (
        <section className="cv-section">
            <h2>Skills</h2>
            <div className="cv-skills">
                {skills?.map((skill) => (
                    <div key={skill.name} className="cv-skill">
                        <span>{skill.name}</span>
                        <strong>{calculateYears(skill.from)}</strong>
                    </div>
                ))}
            </div>
        </section>
    );
}
